import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "juou-card" }

import {
  useBaseAsync,
  type HpsfirProTableColumn,
  type HpsfirProTableData,
  type HpsfirProTableFilter,
  type HpsfirProTableGetDataFunction,
} from 'hpsfir-managebase-ui';

import { useApi } from '../../../hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import dayjs from 'dayjs';
import { normalizeBizTableColumns } from '@/utils/tableColumns';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const columns = ref<HpsfirProTableColumn[]>(normalizeBizTableColumns([]));
const tableRef = ref<any>();
const loading = ref(false);

const addInitValue = {};
const conditionsInitValue = {};

const init = useBaseAsync(() => {
  columns.value = normalizeBizTableColumns([
    {
      name: 'sequenceNumber',
      label: '序号',
      type: 'number',

      hideEdit: true,
      hideCreate: true,
    },
    {
      name: 'adCode',
      label: '广告编码',
      type: 'string',
      isCondition: true,
      rule: [{ required: true, message: '请输入广告编码' }],
    },
    {
      name: 'beanCount',
      label: 'AI豆数量',
      type: 'number',
      rule: [{ required: true, message: '请输入AI豆数量' }],
    },
    {
      name: 'dailyLimit',
      label: '每日限制',
      type: 'number',
      rule: [{ required: true, message: '请输入每日限制次数' }],
    },
    {
      name: 'isHidden',
      label: '是否隐藏',
      type: 'select',
      options: [
        { label: '显示', value: 0 },
        { label: '隐藏', value: 1 },
      ],
      rule: [{ required: true, message: '请选择是否隐藏' }],
    },
    {
      name: 'createTime',
      label: '创建时间',
      type: 'string',
      hideEdit: true,
      hideCreate: true,
      render: (scope: any) => (scope?.row?.createTime ? dayjs(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss') : ''),
    },
  ]);
});

// 获取数据
const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;

    // 处理查询条件，确保不会有undefined或null值
    const processedConditions = Object.entries(filter.conditions || {}).reduce((acc, [key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        acc[key] = value;
      }
      return acc;
    }, {} as Record<string, any>);

    const res = await useApi().incentivePlanApi.pageIncentivePlanincentivePlan({
      conditions: processedConditions,
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
    });

    const tableData: HpsfirProTableData = {
      data: res.data.data?.data || [],
      total: res.data.data?.total || 0,
    };

    return tableData;
  } catch (error) {
    console.error('获取数据失败:', error);
    ElMessage.error('获取数据失败');
    return {
      data: [],
      total: 0,
    };
  } finally {
    loading.value = false;
  }
});

// 添加激励套餐
const addFun = useBaseAsync(async(formData: any) => {
  try {
    loading.value = true;

    const res = await useApi().incentivePlanApi.addIncentivePlanincentivePlan({
      incentivePlanAdminVo: {
        adCode: formData.adCode,
        beanCount: formData.beanCount,
        dailyLimit: formData.dailyLimit,
      },
    });

    tableRef.value?.refresh();
    return true;
  } catch (error) {
    console.error('添加失败:', error);
    ElMessage.error('添加失败');
    return false;
  } finally {
    loading.value = false;
  }
});

// 更新激励套餐
const updateFun = useBaseAsync(async(formData: any) => {
  try {
    loading.value = true;

    const res = await useApi().incentivePlanApi.updateIncentivePlanincentivePlan({
      incentivePlanAdminVo: {
        id: formData.id,
        adCode: formData.adCode,
        beanCount: formData.beanCount,
        dailyLimit: formData.dailyLimit,
      },
    });


    ElMessage.success('更新成功');
    tableRef.value?.refresh();
    return false;
  } catch (error) {
    console.error('更新失败:', error);
    ElMessage.error('更新失败');
    return false;
  } finally {
    loading.value = false;
  }
});

// 删除激励套餐
const deleteFun = useBaseAsync(async(row: any) => {
  try {
    loading.value = true;

    const res = await useApi().incentivePlanApi.delIncentivePlanincentivePlan(row.id);


    ElMessage.success('删除成功');
    tableRef.value?.refresh();
    return false;
  } catch (error) {
    console.error('删除失败:', error);
    ElMessage.error('删除失败');
    return false;
  } finally {
    loading.value = false;
  }
});

// 格式化删除信息
const formatDeleteInfo = (row: any) => `确定要删除广告编码为 "${row.adCode}" 的激励套餐吗？`;

// 初始化
init();

return (_ctx: any,_cache: any) => {
  const _component_HpsfirProTable = _resolveComponent("HpsfirProTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HpsfirProTable, {
      ref_key: "tableRef",
      ref: tableRef,
      "export-file-name": "激励套餐管理",
      title: "激励套餐管理",
      paginations: { pageSize: 10 },
      columns: columns.value,
      "get-data": _unref(getData),
      "on-add": _unref(addFun),
      "on-delete": _unref(deleteFun),
      "on-edit": _unref(updateFun),
      loading: loading.value,
      "is-dangder-delete": true,
      "format-dangder-delete-info": formatDeleteInfo,
      "row-key": 'id',
      "add-init-values": addInitValue,
      "condition-init-values": conditionsInitValue
    }, null, 8, ["columns", "get-data", "on-add", "on-delete", "on-edit", "loading"])
  ]))
}
}

})